import { combineReducers } from '@reduxjs/toolkit';

import { compCompareDialogSlice } from './compCompareDialog.slice';
import { refetchCompsSlice } from './refetchComps.slice';
import { reportConfigSlice } from './reportConfig.slice';

export const REPORT_API_REDUCER_KEY = 'reportApi';
export const reportApiReducer = combineReducers({
  [compCompareDialogSlice.name]: compCompareDialogSlice.reducer,
  [reportConfigSlice.name]: reportConfigSlice.reducer,
  [refetchCompsSlice.name]: refetchCompsSlice.reducer,
});
